(function () {
  if (!document.getElementById('quiz')) return;

  // Respect the OS "reduce motion" setting for JS-driven scrolling/animation.
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const products = {
    uno: {
      name: 'Priva Tugger',
      handle: 'priva-tug',
      tag: 'The first step',
      img: null,
      why: 'A single-piece TPU tugger, the lightest, most accessible Priva device. The ideal first step before committing to a full kit.'
    },
    trio: {
      name: 'Priva Packer',
      handle: 'priva-packer',
      tag: 'The everyday companion',
      img: null,
      why: 'An all-in-one magnetic retainer that tugs, packs, and retains. The most practical place to start a restoration practice, and the easiest to live with day to day.'
    },
    air: {
      name: 'Priva Air',
      handle: 'priva-air',
      tag: 'Controlled inflation',
      img: null,
      why: 'Direct-air inflation with three interchangeable grippers. Ideal when you want controlled, measured inflation and a different stimulus than passive tugging.'
    },
    duo: {
      name: 'Priva Duo',
      handle: 'priva-duo',
      tag: 'The advanced instrument',
      img: null,
      why: 'Dual-tension packing with extendable magnetic plates and a built-in tension indicator. Built for restorers who want measurable, fine-tuned progression.'
    }
  };

  const weights = {
    stage: {
      early:  { uno: 5, trio: 4, air: 1, duo: 0 },
      mid:    { uno: 1, trio: 3, air: 3, duo: 2 },
      late:   { uno: 0, trio: 1, air: 2, duo: 4 },
      unsure: { uno: 4, trio: 3, air: 1, duo: 0 }
    },
    focus: {
      coverage: { uno: 4, trio: 5, air: 1, duo: 2 },
      quality:  { uno: 0, trio: 1, air: 5, duo: 4 },
      both:     { uno: 2, trio: 3, air: 3, duo: 3 },
      unsure:   { uno: 3, trio: 3, air: 1, duo: 0 }
    },
    method: {
      allinone: { uno: 1, trio: 4, air: 0, duo: 1 },
      air:      { uno: 0, trio: 0, air: 5, duo: 0 },
      dual:     { uno: 0, trio: 0, air: 0, duo: 5 },
      open:     { uno: 3, trio: 3, air: 2, duo: 1 }
    },
    wear: {
      day:     { uno: 3, trio: 3, air: 0, duo: 2 },
      night:   { uno: 2, trio: 2, air: 1, duo: 3 },
      both:    { uno: 2, trio: 3, air: 1, duo: 2 },
      session: { uno: 3, trio: 1, air: 4, duo: 1 }
    },
    exp: {
      new:      { uno: 5, trio: 3, air: 1, duo: 0 },
      some:     { uno: 2, trio: 4, air: 2, duo: 1 },
      advanced: { uno: 0, trio: 0, air: 2, duo: 4 }
    },
    budget: {
      low:  { uno: 5, trio: 3, air: 0, duo: 0 },
      mid:  { uno: 1, trio: 3, air: 4, duo: 0 },
      high: { uno: 0, trio: 1, air: 2, duo: 4 }
    }
  };

  const steps = Array.from(document.querySelectorAll('.quiz-step'));
  const progressDots = document.querySelectorAll('#progressBar span');
  let current = 0;

  function show(i) {
    steps.forEach(s => s.classList.remove('active'));
    steps[i].classList.add('active');
    progressDots.forEach((d, idx) => {
      d.classList.remove('active', 'done');
      if (idx < i) d.classList.add('done');
      if (idx === i && i < progressDots.length) d.classList.add('active');
    });
    current = i;
    const quizEl = document.getElementById('quiz');
    if (quizEl) {
      const rect = quizEl.getBoundingClientRect();
      const headerOffset = 80;
      if (rect.top < -40 || rect.top > window.innerHeight * 0.6) {
        window.scrollTo({ top: window.scrollY + rect.top - headerOffset, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
    }
  }

  document.querySelectorAll('.quiz-option').forEach(opt => {
    const input = opt.querySelector('input');
    function select() {
      const name = input.name;
      document.querySelectorAll(`.quiz-option input[name="${name}"]`).forEach(i => {
        i.closest('.quiz-option').classList.remove('selected');
      });
      input.checked = true;
      opt.classList.add('selected');
    }
    opt.addEventListener('click', select);
    // Keyboard: arrow keys / Space on the (visually hidden) radio fire change.
    input.addEventListener('change', select);
  });

  function currentStepValid() {
    const step = steps[current];
    const input = step.querySelector('input[type=radio]');
    if (!input) return true;
    const name = input.name;
    return !!step.querySelector(`input[name="${name}"]:checked`);
  }

  document.querySelectorAll('[data-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!currentStepValid()) {
        if (!reduceMotion()) btn.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
          { duration: 200 }
        );
        return;
      }
      show(current + 1);
    });
  });
  document.querySelectorAll('[data-prev]').forEach(btn => {
    btn.addEventListener('click', () => show(current - 1));
  });

  document.getElementById('seeResult')?.addEventListener('click', () => {
    if (!currentStepValid()) return;
    const answers = {
      stage:  document.querySelector('input[name=stage]:checked').value,
      focus:  document.querySelector('input[name=focus]:checked').value,
      method: document.querySelector('input[name=method]:checked').value,
      wear:   document.querySelector('input[name=wear]:checked').value,
      exp:    document.querySelector('input[name=exp]:checked').value,
      budget: document.querySelector('input[name=budget]:checked').value
    };

    const scores = { uno: 0, trio: 0, air: 0, duo: 0 };
    Object.keys(answers).forEach(key => {
      const w = weights[key][answers[key]];
      Object.keys(w).forEach(p => { scores[p] += w[p]; });
    });

    const ranked = Object.keys(scores).sort((a, b) => scores[b] - scores[a]);
    const top = products[ranked[0]];
    const alt = products[ranked[1]];

    document.getElementById('rec-tag').textContent = top.tag;
    document.getElementById('rec-name').textContent = top.name;
    document.getElementById('rec-why').textContent = top.why;
    const shopLink = document.getElementById('rec-shop');
    if (shopLink) shopLink.href = '/products/' + top.handle;
    const recLink = document.getElementById('rec-link');
    if (recLink) recLink.href = '/products/' + top.handle;
    document.getElementById('rec-img').innerHTML = top.img
      ? `<img src="${top.img}" alt="${top.name}">`
      : `<div class="product-media-placeholder"><div class="mark">${top.name.replace('Priva ', '')}</div><div class="sub">Photo · coming</div></div>`;
    document.getElementById('rec-alt').innerHTML =
      `Also worth considering, <a href="/products/${alt.handle}">${alt.name}</a> · ${alt.tag.toLowerCase()}.`;

    show(steps.length - 1);
  });

  document.getElementById('restart')?.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
    document.querySelectorAll('.quiz input[type=radio]').forEach(i => i.checked = false);
    show(0);
  });

  show(0);
})();
